import { apiRequest } from './apiClient.js';

export const quoteService = { requestEstimate: (payload) => apiRequest('/quotes/estimate', { method: 'POST', body: JSON.stringify(payload) }) };